import { render } from "./IconDark.vue?vue&type=template&id=7cd81c7c&ts=true"
import script from "./IconDark.vue?vue&type=script&lang=ts"
export * from "./IconDark.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__